import httpClient from "@/services/HttpService";

export default {
    user: () => {
        return httpClient.get('/auth/user');
    }
}


